module.exports = __webpack_public_path__ + "img/snd.8a729589.jpg";